import _extends from "@babel/runtime/helpers/extends";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import React from 'react';
var PREFIX = 'ppfish&';
export function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}
export function warn() {
  if (console && console.warn) {
    var _console;
    (_console = console).warn.apply(_console, arguments);
  }
}
var alreadyWarned = {};
export function warnOnce() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}

/**
 * 多级属性设置
 * @param obj
 * @param arr
 * @param value
 */
export function setAttr(obj, arr, value) {
  if (!Array.isArray(arr) || !arr.length) {
    return obj;
  }
  var data = obj;
  for (var i = 0, len = arr.length; i < len; i++) {
    if (i === len - 1) {
      data[arr[i]] = value;
    } else {
      var defaultData = arr[i] === 'MONTH_ARRAY' ? [] : {};
      data = data[arr[i]] = data[arr[i]] || defaultData;
    }
  }
}

/**
 * 格式化ppfish的国际化的key，树结构
 * @param langJson
 */
export function formatPpfish(langJson) {
  var res = {};
  var splitText = '&';
  if (!langJson || !Object.keys(langJson).length) {
    return res;
  }
  for (var _i = 0, _Object$keys = Object.keys(langJson); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    var splitKey = key.replace(/^ppfish&/i, '');
    if (!splitKey.includes(splitText)) {
      res[splitKey] = langJson[key];
      continue;
    }
    var keyArr = splitKey.split(splitText);
    setAttr(res, keyArr, langJson[key]);
  }
  return res;
}

/**
 * 把树形结构的对象打平
 * @param {Object} tree
 * @param {String} tag
 */
export function expandTreeKey(tree, tag) {
  if (tag === void 0) {
    tag = '&';
  }
  var res = {};
  if (!tree || !Object.keys(tree).length) {
    return res;
  }
  var expandFun = function expandFun(obj, hisKey) {
    for (var _i2 = 0, _Object$keys2 = Object.keys(obj); _i2 < _Object$keys2.length; _i2++) {
      var key = _Object$keys2[_i2];
      if (typeof obj[key] === 'object') {
        expandFun(obj[key], hisKey ? "" + hisKey + tag + key : key);
      } else {
        res[hisKey ? "" + hisKey + tag + key : key] = obj[key];
      }
    }
  };
  expandFun(tree, '');
  var ppfishRes = {};
  for (var _i3 = 0, _Object$keys3 = Object.keys(res); _i3 < _Object$keys3.length; _i3++) {
    var key = _Object$keys3[_i3];
    if (key) {
      ppfishRes["" + PREFIX + key] = res[key];
    }
  }
  return ppfishRes;
}

/**
 * 多语言插槽匹配， ---${value}标识插槽
 * @param {String} val
 * @param {String | Number} args
 * @returns {String}
 */
export var replaceSlot = function replaceSlot(val) {
  // eslint-disable-next-line no-template-curly-in-string
  var KEY = /\${\w+}/;
  if (!KEY.test(val)) {
    return val;
  }
  var res = val;
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }
  for (var _i4 = 0, _args = args; _i4 < _args.length; _i4++) {
    var item = _args[_i4];
    res = res.replace(KEY, item);
  }
  return res;
};

/**
 * 多语言插槽匹配， ---${value}标识插槽
 * @param {String} val
 * @param {String | Number} args
 * @returns {String}
 */
export var replaceSlotHTML = function replaceSlotHTML(val) {
  // eslint-disable-next-line no-template-curly-in-string
  var KEY = /\${\w+}/;
  if (!KEY.test(val)) {
    return val;
  }
  var res = val;
  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }
  for (var _i5 = 0, _args2 = args; _i5 < _args2.length; _i5++) {
    var item = _args2[_i5];
    res = res.replace(KEY, item);
  }
  var el = /*#__PURE__*/React.createElement('span', {
    dangerouslySetInnerHTML: {
      __html: res
    }
  });
  return Object.assign({}, el);
};

/**
 * 多语言平台接口查过来的数据处理
 * @param data
 */
export var formatResultData = function formatResultData(data) {
  var res = {};
  var ppfishKey = 'ppfish';
  if (!data || !Object.keys(data)) {
    return res;
  }
  for (var _i6 = 0, _Object$keys4 = Object.keys(data); _i6 < _Object$keys4.length; _i6++) {
    var key = _Object$keys4[_i6];
    if (key === ppfishKey && Object.keys(data[ppfishKey]).length) {
      res[ppfishKey] = data[ppfishKey];
      continue;
    }
    res.normal = _extends({}, res.normal || {}, data[key]);
  }
  if (res.ppfish) {
    res.ppfish = formatPpfish(res.ppfish);
  }
  return res;
};

/**
 * 格式化nbsp为普通空格
 * @param {String} lang
 */
export var formatNBSP = function formatNBSP(value) {
  return decodeURIComponent(encodeURIComponent(value).replace(/%C2%A0/g, '%20'));
};

/**
 * 格式化antd语言格式为 zh_CN 这种
 * @param {String} lang
 */
export var formatAntdLang = function formatAntdLang(lang) {
  if (lang.includes('-') || lang.includes('_')) {
    var arr = lang.replace('-', '_').split('_');
    return arr[0].toLowerCase() + "_" + arr[1].toUpperCase();
  }
  // antd语言包的映射
  var ANTD_LANG_MAP = {
    'zh-cn': 'zh_CN',
    // 中文简体
    'zh-tw': 'zh_TW',
    // 中文繁体
    en: 'en_US',
    // 英文
    ar: 'ar_EG',
    // 阿拉伯语
    de: 'de_DE',
    // 德语
    ru: 'ru_RU',
    // 俄语
    fr: 'fr_FR',
    // 法语
    ko: 'ko_KR',
    // 韩语
    pt: 'pt_PT',
    // 葡萄牙语
    ja: 'ja_JP',
    // 日语
    th: 'th_TH',
    // 泰语
    tr: 'tr_TR',
    // 土耳其语
    es: 'es_ES',
    // 西班牙语
    id: 'id_ID',
    // 印尼语
    vi: 'vi_VN' // 越南语
  };
  return ANTD_LANG_MAP[lang.toLowerCase()] || lang;
};

/**
 * BCP47语言标记的映射清单
 */
export var BCP47_LANG_MAP = {
  'zh-cn': 'zh-Hans-CN',
  // 中文简体
  'zh-tw': 'zh-Hant-TW',
  // 中文繁体
  en: 'en',
  // 英文
  ar: 'ar-eg',
  // 阿拉伯语
  de: 'de',
  // 德语
  ru: 'ru',
  // 俄语
  fr: 'fr',
  // 法语
  ko: 'ko',
  // 韩语
  pt: 'pt',
  // 葡萄牙语
  ja: 'ja',
  // 日语
  th: 'th',
  // 泰语
  tr: 'tr',
  // 土耳其语
  es: 'es',
  // 西班牙语
  id: 'id',
  // 印尼语
  vi: 'vi',
  // 越南语
  tl: 'fil' // 菲律宾语在BCP47中为fil
};

/**
 * 检测当前传入的语言是否是支持的语言
 * @param  {String} lang         语言
 * @return {Boolean}
 */
export var supportLang = function supportLang(lang) {
  return Object.keys(BCP47_LANG_MAP).includes(lang);
};

/**
 * 函数传入lang兼容预处理
 * @param  {String} lang         语言
 * @return {String}
 */
export var compatibleLang = function compatibleLang(lang) {
  // 传入参数不是字符串，直接返回true
  if (typeof lang !== 'string') {
    return 'zh-cn';
  }
  lang = lang.toLowerCase();
  if (!supportLang(lang)) {
    return 'zh-cn';
  }
  return lang;
};